import { ALERTA, strToDate, todayStr } from "@/lib/agenda";
import { nombreTourDisplay } from "@/lib/tourDisplay";

export default function SemanaView({ dias = [], onSelect }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-7 gap-3" data-testid="agenda-semana">
      {dias.map((d) => {
        const fd = strToDate(d.fecha);
        const esHoy = d.fecha === todayStr();
        return (
          <div key={d.fecha} className="min-w-0" data-testid={`semana-dia-${d.fecha}`}>
            <div
              className={`rounded-t-lg px-2.5 py-2 text-center ${
                esHoy ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600"
              }`}
            >
              <p className="text-[10px] uppercase tracking-wide capitalize">
                {fd.toLocaleDateString("es-ES", { weekday: "short" })}
              </p>
              <p className="text-base font-bold leading-tight">{fd.getDate()}</p>
            </div>
            <div className="space-y-1.5 p-1.5 bg-slate-50/70 rounded-b-lg min-h-[90px]">
              {d.salidas.length === 0 ? (
                <p className="text-[10px] text-slate-300 text-center py-4">Sin salidas</p>
              ) : (
                d.salidas.map((s) => {
                  const a = ALERTA[s.alerta] || ALERTA.verde;
                  return (
                    <button
                      key={s.id}
                      onClick={() => onSelect(s)}
                      data-testid={`semana-salida-${s.id}`}
                      className="w-full text-left rounded-md border border-slate-200 bg-white p-1.5 hover:border-slate-400 transition-colors"
                    >
                      <div className="flex items-center justify-between">
                        <span className="text-[11px] font-bold tabular-nums text-slate-800">{s.hora}</span>
                        <span className={`h-2 w-2 rounded-full ${a.dot}`} />
                      </div>
                      <p className="text-[10px] text-slate-600 truncate leading-tight">{nombreTourDisplay(s.tour_nombre, s.modalidad)}</p>
                      <p className="text-[10px] font-medium tabular-nums text-slate-500">
                        {s.cupo_usado}/{s.cupo_max || "—"}
                      </p>
                    </button>
                  );
                })
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
